import 'styles/avatar.css'
import { classNames } from 'utils'

/**
 * Componente Avatar
 * @param {object} props Propiedades del componente
 * @param {React.ReactNode | undefined} props.children Contenido del Avatar.
 * @param {'rounded' | 'circular' | 'square' | string | undefined} props.shape Forma del Avatar.
 * @param {string | undefined} props.className Clase de estilos del componente.
 * @param {React.CSSProperties | undefined} props.style Estilos en linea del Avatar.
 * @param {'sm' | 'lg' | string | undefined} props.size Tamaño del Avatar.
 * @param {object | undefined} props.imgProps Propiedades de la imagen. El Avatar se toma como imagen.
 * @param {object | undefined} props Propiedades del icono. El avatar se toma como icono.
 * @returns {JSX.Element} Retorna el componente Avatar
 */
export default function Avatar({ children, className, iconProps, imgProps, shape, size, style }) {
    return (
        <div
            className={classNames(['avatar', className, `avatar-${shape || 'circular'}`, size && `avatar-${size}`])}
            style={style}
        >
            {children ||
                (typeof imgProps === 'object' ? <img alt='' {...imgProps} /> : '') ||
                (typeof iconProps === 'object' ? <span {...iconProps}></span> : '')}
        </div>
    )
}
